import React from 'react';
import PropTypes from 'prop-types';

// styles
import './FilterBtns.css';

// icons
import SVGInline from "react-svg-inline";
import filterBtnSVG from "../../inlineSVGs/filterBtnSVG";
import {BAND, LIVE_MUSIC, MUSICIAN, SERVICE} from "../../../consts";
import {AnalyticsService} from "../../../Services";

const FilterBtns = ({ adType, handleFilterClick, handleCreateAdClick, customClass }) => {

    const getLocalBtnText = () => {
        if (adType === LIVE_MUSIC) return 'פרסם הופעה'
        if (adType === SERVICE) return 'פרסם שירות מוזיקלי'
        if (adType === BAND) return 'מצא להקה'
        if (adType === MUSICIAN) return 'מצא מוזיקאי חסר'
    }

    const handleLargeBtnClick = () => {
        let event = AnalyticsService.events.PARTICIPATE_MAIN;
        switch(adType) {
            case LIVE_MUSIC:
                event = AnalyticsService.events.PARTICIPATE_MOBILE_LIVE_MUSIC;
                break;
            case SERVICE:
                event = AnalyticsService.events.PARTICIPATE_MOBILE_SERVICE;
                break;
            case BAND:
                event = AnalyticsService.events.PARTICIPATE_MOBILE_BAND;
                break;
            case MUSICIAN:
                event = AnalyticsService.events.PARTICIPATE_MOBILE_MUSICIAN;
        }

        AnalyticsService.sendEvent(event);
        handleCreateAdClick();
    }

    return (
        <div className={`filter-btns-container ${customClass ? customClass : ''}`}>
            <div className={`filter-btn-wrapper create-ad-btn ${adType}`} onClick={() => handleLargeBtnClick()}>
                <span>{getLocalBtnText()}</span>
                <span>+</span>
            </div>
            <div className={`filter-btn-wrapper ${adType}`} onClick={() => handleFilterClick()}>
                <SVGInline svg={filterBtnSVG} width="22px" className="filter-icon" />
            </div>
        </div>
    )
};

FilterBtns.propTypes = {
    handleFilterClick: PropTypes.func,
    handleCreateAdClick: PropTypes.func,
    customClass: PropTypes.string,
    adType: PropTypes.string
};

export default FilterBtns;



// WEBPACK FOOTER //
// ./src/Components/Elements/Mobile/FiltersBtns.js